





















































import { Component, Vue, Mixins, Watch, Prop } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import moment from 'moment';
import * as api from '../../../../api/reconciliation-management';
import { IPayRecordSelect } from './types';
import _ from 'lodash';

@Component
export default class PayRecordSelect extends Mixins(TableMixin, TableWidthMixin) implements IPayRecordSelect {
  //选择的车场
  @Prop()
  selectPark: any;

  //已经选择的缴费记录id列表
  @Prop()
  selectedRecordIdList: string[] = [];

  //时间范围
  defaultTimeRage: any[] = [];
  timeRange: any[] = [];

  filterParam: any = {
    bizType: '',
    startTime: '',
    endTime: '',
    payee: '',
    payer: ''
  };
  onTimeRangeChange() {
    console.log(this.timeRange);
    this.filterParam.startTime = this.timeRange[0].format('YYYY-MM-DD HH:mm:ss');
    this.filterParam.endTime = this.timeRange[1].format('YYYY-MM-DD HH:mm:ss');
  }

  clear() {
    this.filterParam = {
      bizType: '',
      startTime: '',
      endTime: '',
      payee: '',
      payer: ''
    };
    this.timeRange = this.defaultTimeRage;
    this.onTimeRangeChange();
  }

  search() {
    this.current = 1;
    // 清除选中
    this.selectedRowKeys = [];
    this.fetchTableData();
  }
  showSizeChangerChange(current: any, pageSize: any) {
    this.current = current;
    this.pageSize = pageSize;
    this.fetchTableData();
  }

  current: number = 1;
  pageSize: number = 10;
  total: number = 0;
  // 留着所有选择的数据，用于计算总金额和返回给父页面
  tableDataAll: any[] = [];
  tableData: any[] = [];
  tableLoading: boolean = false;
  selectedRowKeys: string[] = [];
  get tableColums() {
    return [
      {
        title: '费用类型',
        dataIndex: 'bizType'
      },
      {
        title: '支付方式',
        dataIndex: 'payMethod'
      },
      {
        title: '金额',
        dataIndex: 'paidPrice',
        customRender: this.numberRender
      },
      {
        title: '缴款人',
        dataIndex: 'payer'
      },
      {
        title: '收款人',
        dataIndex: 'payee'
      },
      {
        title: '交易时间',
        dataIndex: 'tradeTime',
        width: 200
      },
      {
        title: '期间',
        dataIndex: 'tradeDay'
      }
    ];
  }

  numberRender(value: number) {
    if (isNaN(value)) {
      return value;
    } else {
      const num = (value / 100).toFixed(2);
      return num.replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
    }
  }

  async fetchTableData() {
    if (!this.selectPark) {
      return;
    }
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;

      const res = await api.getEasPayRecordPageList({
        parkId: this.selectPark.value,
        selectedRecordIdList: this.selectedRecordIdList,
        // 查出全部
        page: this.current,
        pageSize: this.pageSize,
        ...this.filterParam
      });

      const data = res.data;
      if (data) {
        const { pageSize = 0, currPage = 0, totalPage, totalNum = 0, datas = [], total } = data;
        this.total = Number(totalNum);
        this.tableData = datas;
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }

  onSelectChange(selectedRowKeys: string[], selectedRows: _.List<any> | null | undefined) {
    console.log(selectedRowKeys, selectedRows);
    this.selectedRowKeys = selectedRowKeys;
    this.tableDataAll = _.unionBy(this.tableDataAll, selectedRows, 'easPayRecordId');
  }

  message: string = '已选择 0 项   金额总计：0.00元';
  @Watch('selectedRowKeys')
  selectedRowKeysChange() {
    const selectRows = this.getSelectedRecordIdList();
    const sum = _.sumBy(selectRows, 'paidPrice');
    this.message = `已选择 ${selectRows.length} 项   金额总计：${this.numberRender(sum)}元`;
  }

  created(): void {
    const start = moment()
      .subtract(1, 'd')
      .subtract(1, 'month')
      .startOf('d');
    const end = moment()
      .subtract(1, 'd')
      .endOf('d');
    this.timeRange = [start, end];
    this.defaultTimeRage = this.timeRange;
    this.onTimeRangeChange();
    this.fetchTableData();
  }

  // 对外方法
  public getSelectedRecordIdList(): any[] {
    return this.tableDataAll.filter(i => this.selectedRowKeys.find(k => k === i.easPayRecordId));
  }
}
